import type { FunctionComponent } from 'react';
import { useCallback, useEffect } from 'react';

import { PromotionsCustomEvents } from '../../components/promotionsV2/helper/customEvents';
import { Logger } from '../../logger/Logger';
import { useFreeChipsFetcher } from '../../store/apiHooks/useFreeChipsFetcher';
import { useBonusPromotionsSlice } from '../../store/slices/bonusPromotions/selectors';

export const FreeChipConnector: FunctionComponent = (): null => {
  const refetchCampaign = useBonusPromotionsSlice.getRefetchCampaign();
  const freeChipsFetcher = useFreeChipsFetcher();

  const handleClaimBonus = useCallback((event: CustomEvent<{ bonusId: number }>) => {
    const { bonusId } = event.detail;
    Logger.logEvent('freeChipsClaimed', { additional: 'bonusId' + bonusId });
  }, []);

  useEffect(() => {
    window.addEventListener(PromotionsCustomEvents.OnClaimBonus, handleClaimBonus as EventListener);

    return (): void => {
      window.removeEventListener(PromotionsCustomEvents.OnClaimBonus, handleClaimBonus as EventListener);
    };
  }, [handleClaimBonus]);

  useEffect(() => {
    if (refetchCampaign) {
      freeChipsFetcher();
    }
  }, [refetchCampaign, freeChipsFetcher]);

  return null;
};
